var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Component_22_1","data-name":"Component 22 – 1","transform":"translate(0.53 0.53)"},React.createElement("path",{"id":"Path_1449","data-name":"Path 1449","d":"M13015.964,1494.526l5.5,5.5,5.5-5.5","transform":"translate(-13015.964 -1494.526)","fill":"none","stroke":"#000","strokeWidth":"1.5"})));
}

DownArrow.defaultProps = {"width":"12.067","height":"7.095","viewBox":"0 0 12.067 7.095"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
